module.exports = __webpack_public_path__ + "img/ritz-4.0e5d0e74.jpeg";